import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-aviso',
  templateUrl: './modal-aviso.component.html',
  styleUrls: ['./modal-aviso.component.sass']
})
export class ModalAvisoComponent implements OnInit {
  listaAvisos: string[] = [
    'Filho(a) Menor ou Enteado – Cópia da Certidão de Nascimento ou RG – filho(a) até 24 anos, onze meses e vinte e nove dias completos;',
    'Filho(a) Inválido(a) – Cópia da Certidão de Nascimento ou RG e Relatório Médico; ',
    'Cônjuge/Companheiro(a) – Cópia da Certidão de Casamento ou Contrato de União Estável, por instrumento público de existência da união estável; ',
    'Apresentação de quitação do boleto bancário, recibo e/ou nota fiscal, emitidos pelas empresas operadoras de plano ou seguro-saúde/odontológico, ficando isento de apresentar a comprovação exigida o servidor ou Magistrado cujos os custos de saúde sejam descontados, mês a mês, diretamente na folha de pagamento do Poder Judiciário, quando o contrato com a operadora de saúde ou seguro de saúde for controlado pela Diretoria de Recursos Humanos – DRH; ',
    'Comprovante de Renda do órgão de origem – quando for servidor cedido ao TJBA e beneficiário do PLANSERV no órgão de origem; ',
    'Comprovante de Renda do Titular (Cônjuge/Genitor) – quando for dependente de cônjuge ou de genitor com PLANSERV em outro órgão;',
    'Comprovante de Renda do outro órgão – quando o servidor ocupar mais de um cargo público estadual e for beneficiário do PLANSERV em outro órgão;Obs. Para os filhos e/ou enteados com idade entre vinte e um (21) anos e 24 anos, onze meses e vinte e nove dias completos, é imprescindível apresentar a declaração de matrícula de nível superior.',
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
